document.addEventListener("DOMContentLoaded", function () {
  // News Archive Module - Category Filter
  let categoriesWrapper = document.querySelector(
    ".news-filters__categories .categories__wrapper"
  );
  if (!categoriesWrapper) return;
  // Toggle visibility of category list on click
  categoriesWrapper
    .querySelector("span")
    .addEventListener("click", function () {
      let categoryList = categoriesWrapper.querySelector("ul");
      categoryList.style.display =
        categoryList.style.display === "none" ? "flex" : "none";
    });
});
